<template>
  <div>
    <!--  -->
    <filter-bar
      name="tickets"
      :filters="filters"
      @reset="refresh"
      @filtrer="filtrer"
      @search="search"
    />
    <!--  -->
    <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center">
      <!--  -->
      <div class="bg-white w-full rounded-lg shadow">
        <div class="h-20 py-3 flex items-center p-6">
          <!--  -->
          <div class="flex">
            <div class="text-2xl font-bold text-blue-700">Tickets</div>
          </div>
          <!--  -->
          <div class="w-full flex justify-end">
            <router-link
              class="flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-blue-600 hover:shadow-inner hover:bg-blue-600  transition-all duration-300"
              to="/tickets/new"
            >
              <i class="material-icons">add</i> New ticket
            </router-link>
          </div>
        </div>
      </div>
      <!--  -->

      <!--  -->
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <!--  -->

      <!--  -->
      <table class="min-w-full leading-normal">
        <!--  -->
        <thead>
          <!--  -->
          <tr>
            <!--  -->
            <th
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              Ticket ID
            </th>
            <!--  -->
            <th  v-if="currentUser.type != 'Seller'"
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              seller
            </th>
            <!--  -->
            <th
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              Subject
            </th>
            <!--  -->
            <th
            class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              Creation Date
            </th>
          <!--  -->
            <th
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              Department
            </th>
            <!--  -->
            <th
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              priority
            </th>
            <!--  -->
            <th
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              status
            </th>
            <!--  -->
            <th
              class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
            >
              actions
            </th>
            <!--  -->
          </tr>
          <!--  -->
        </thead>
        <!--  -->

        <!--  -->
        <tbody v-for="(ticket, index) in tickets" :key="index">
          <tr>
            <!-- Ticket ID -->
            <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
              <div
                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
              >
                {{ ticket.ticketId }}
              </div>
            </td>
            <!-- Ticket ID-->

            <!-- Sellers -->
            <td v-if="currentUser.type != 'Seller'" class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
              <div
                class="text-xs leading-5 capitalize rounded-full text-gray-900"
              >
                <p class="flex whitespace-no-wrap">
                  <button
                    @click="showSellers(index)"
                    :class="$colors.newColor"
                    class="bg-gray-100 rounded-full flex items-center text-2xl focus:outline-none p-1"
                  >
                    <i
                      class="material-icons"
                      style="transition: 0.3s"
                      :style="
                        element && element._id == ticket._id
                          ? 'transform: rotate(180deg)'
                          : ''
                      "
                      >keyboard_arrow_down</i
                    >
                  </button>
                  <span class="mt-1 ml-2">{{ ticket.seller.fullName }}</span>
                </p>
              </div>
            </td>
            <!-- Sellers -->

            <!-- Subject -->
            <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
              <div
                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
              >
                {{
                  ticket.subject.length > 20
                    ? ticket.subject.slice(0, 20) + "..."
                    : ticket.subject
                }}
              </div>
            </td>
            <!-- Subject -->
            
            <!-- Created Date -->
            <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
              <div
                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
              >
                {{ $moment(ticket.createdAt).format("yyyy-MM-DD HH:mm") }}
              </div>
            </td>
            <!-- Created Date -->

            <!-- Department -->
            <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
              <div
                class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
              >
                {{ ticket.department.name }}
              </div>
            </td>
            <!-- Department -->

            <!-- Priority -->
            <td
              class="px-6 py-2 whitespace-no-wrap border-b border-gray-200 text-xs"
            >
              <select
                class="bg-red-400 text-white rounded-md cursor-pointer p-1 focus:outline-none"
                :class="
                  ticket.priority.value == 'low'
                    ? 'bg-green-500'
                    : ticket.priority.value == 'medium'
                    ? 'bg-orange-500'
                    : 'bg-red-500'
                "
                v-model="ticket.priority"
                @change="updateElement(ticket._id, ticket.priority, 'priority')"
              >
                <option
                  class="bg-white text-black"
                  v-for="(priority, index) in priorityOptions"
                  :key="index"
                  :value="priority"
                  >{{ priority.name }}</option
                >
              </select>
            </td>
            <!-- Priority -->

            <!-- Status -->
            <td
              class="px-6 py-2 whitespace-no-wrap border-b border-gray-200 text-xs"
            >
              <select
                class="text-white rounded-md cursor-pointer p-1 focus:outline-none"
                :class="
                  ticket.status.value == 'open' ? 'bg-green-500' : 'bg-red-500'
                "
                v-model="ticket.status"
                @change="updateElement(ticket._id, ticket.status, 'status')"
              >
                <option
                  class="bg-white text-black"
                  v-for="(status, index) in statusOptions"
                  :key="index"
                  :value="status"
                  >{{ status.name }}
                </option>
              </select>
            </td>
            <!-- Status -->

            <!-- Actions -->
            <td class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">
              <div class="flex">
                <!--  -->
                <router-link
                  :class="loading ? 'noselect' : ''"
                  :disabled="loading"
                  class="rounded-full flex items-center focus:outline-none w-8 h-8 mr-3 mt-1"
                  :to="{ path: `/tickets/detail/${ticket._id}` }"
                >
                  <i class="material-icons mx-1">remove_red_eye</i>
                </router-link>
                <!--  -->
                <router-link
                  :class="loading ? 'noselect' : ''"
                  :disabled="loading"
                  class="rounded-full flex items-center focus:outline-none w-8 h-8 mr-3 mt-1"
                  :to="{ path: `/tickets/edit/${ticket._id}` }"
                >
                  <i class="material-icons mx-1">edit</i>
                </router-link>
                <!--  -->
                <button
                  @click="remove(ticket._id)"
                  :class="loading ? 'noselect' : ''"
                  :disabled="loading"
                  class="rounded-full flex items-center focus:outline-none w-8 h-8 mr-3 mt-1 relative loidingconfirm"
                >
                  <i class="material-icons mx-1">delete</i>
                </button>
                <!--  -->
              </div>
            </td>
            <!-- Actions -->
          </tr>

          <!-- Sellers -->
          <tr v-if="element && element._id == ticket._id">
            <!--  -->
            <td colspan="7" class="border">
              <!--  -->
              <div class="overflow-auto w-full rounded-2xl">
                <!--  -->
                <table class="table w-full text-center">
                  <!--  -->
                  <thead class="bg-gray-200 text-black">
                    <tr>
                      <th
                        class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                      ></th>
                      <th
                        class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                      >
                        fullname
                      </th>
                      <th
                        class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                      >
                        type
                      </th>
                      <th
                        class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                      >
                        email
                      </th>
                      <th
                        class="px-5 py-2 bg-gray-100 text-center text-xs font-semibold text-gray-600 capitalize tracking-wider"
                      ></th>
                    </tr>
                  </thead>
                  <!--  -->

                  <!--  -->
                  <tbody>
                    <!--  -->
                    <tr>
                      <!--  -->
                      <td class="px-6 py-4 whitespace-no-wrap border-gray-200">
                        <div
                          class="text-xs leading-5 capitalize px-2 font-semibold rounded-full text-gray-700"
                        ></div>
                      </td>
                      <!--  -->
                      <td class="px-6 py-4 whitespace-no-wrap border-gray-200">
                        <div
                          class="text-xs leading-5 capitalize px-2 rounded-full text-gray-800"
                        >
                          {{ element.seller.fullName }}
                        </div>
                      </td>
                      <!--  -->
                      <td class="px-6 py-4 whitespace-no-wrap border-gray-200">
                        <div
                          class="text-xs leading-5 capitalize px-2 rounded-full text-gray-800"
                        >
                          {{ element.seller.type }}
                        </div>
                      </td>
                      <!--  -->
                      <td class="px-6 py-4 whitespace-no-wrap border-gray-200">
                        <div
                          class="text-xs leading-5 capitalize px-2 rounded-full text-gray-800"
                        >
                          {{ element.seller.email }}
                        </div>
                      </td>
                      <!--  -->
                      <td class="px-6 py-4 whitespace-no-wrap border-gray-200">
                        <div
                          class="text-xs leading-5 capitalize px-2 rounded-full text-gray-900"
                        ></div>
                      </td>
                      <!--  -->
                    </tr>
                    <!--  -->
                  </tbody>
                  <!--  -->
                </table>
                <!--  -->
              </div>
              <!--  -->
            </td>
            <!--  -->
          </tr>
          <!-- Sellers -->
        </tbody>
      </table>
      <!--  -->

      <!--  -->
      <div v-if="tickets.length <= 0" class="bg-blue-100 py-8">
        <span
          class="w-full flex justify-center text-center py-3 border-b border-gray-200 text-base"
        >
          <p class="font-semibold flex text-blue-500  whitespace-no-wrap">
            <i class="material-icons mx-3">error</i>
            <span class="">No tickets selected </span>
          </p>
        </span>
      </div>
      <!--  -->

      <!-- pagination -->
      <div class="p-1">
        <div class="flex flex-col items-center my-12">
          <div v-if="paginate.lastpage > 1" class="flex text-gray-700">
            <button
              v-if="paginate.currentpage > 1"
              :disabled="paginate.currentpage === 1"
              class="h-8 w-8 focus:outline-none mr-6 flex justify-center text-black items-center rounded-full bg-gray-200 hover:bg-black hover:text-white cursor-pointer"
              @click="prev"
            >
              <i class="material-icons"> keyboard_arrow_left </i>
            </button>
            <div class="flex h-8 font-medium rounded-full bg-gray-200">
              <div
                v-if="paginate.currentpage !== paginate.lastpage"
                class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full bg-black text-white"
              >
                {{ paginate.currentpage }}
              </div>
              <div
                v-else
                class="w-8 md:flex justify-center hover:bg-black hover:text-white items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
              >
                <span v-if="paginate.currentpage !== 1"> 1 </span>
              </div>

              <div
                v-if="paginate.currentpage >= 1 && paginate.lastpage !== 1"
                class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
              >
                ...
              </div>

              <button
                :class="
                  paginate.currentpage === paginate.lastpage
                    ? 'bg-black  text-white'
                    : ' '
                "
                class="w-8 md:flex justify-center items-center hover:bg-black hover:text-white focus:outline-none hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
              >
                {{ paginate.lastpage }}
              </button>
            </div>
            <button
              v-if="paginate.currentpage < paginate.lastpage"
              :disabled="paginate.currentpage === paginate.lastpage"
              class="h-8 w-8 ml-6 focus:outline-none flex justify-center text-black items-center rounded-full bg-gray-200 hover:bg-black hover:text-white cursor-pointer"
              @click="next"
            >
              <i class="material-icons"> keyboard_arrow_right </i>
            </button>
          </div>
        </div>
      </div>
      <!-- pagination -->
    </div>
    <!--  -->
  </div>
</template>

<script>
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      tickets: [],
      sellers: [],
      element: null,
      fullPage: false,
      loading: false,
      priorityOptions: [
        { name: "Low", value: "low" },
        { name: "Medium", value: "medium" },
        { name: "High", value: "high" },
      ],
      statusOptions: [
        { name: "Open", value: "open" },
        { name: "Close", value: "close" },
      ],
      limit: 10,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      filters: {
        name: "tickets",
        elements: {
          search: {
            options: {
              icon: "search",
              label: "search",
              class: "",
              hint: "Search Ticket",
            },
            value: null,
            type: "search",
            validate: {
              trim: true,
              required: false,
              minlength: 0,
            },
          },
          champs: [
            {
              label: "Seller",
              key: "seller",
              value: null,
              values: [],
              class: "py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white",
              type: "select",
            },
          ],
        },
      },
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["warehouses"]),
      });
    },
  },
  watch: {
    idWharhouse: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.reset();
        }
      },
    },
  },
  async mounted() {
    if(this.currentUser.type != "Seller") {
      await this.getTickets({ limit: this.limit });
      await this.getSellers();
    }else {
      delete this.filters.elements.champs;
    }
  },
  methods: {
    async getTickets(filter) {
      this.paginate = {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      }

      filter.warehouse = this.idWharhouse._id;

      if(this.currentUser.type == "Seller"){
        filter.seller = this.currentUser._id
      }

      const res = await this.$server.search("tickets", filter);

      if (res.content && res.content.results) {
        this.tickets = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.tickets = [];
      }
    },
    async updateElement(ticketId, ticketData, fieldType) {
      try {
        const formData = {
          _id: ticketId,
          [fieldType]: ticketData,
        };

        const data = await this.$server.update("tickets", formData);

        if (data) {
          alert(`${fieldType} updated`, "success");
        } else {
          alert(data, "warning");
        }
      } catch (error) {
        console.error(`Error updating ${fieldType}:`, error);
        alert(`An error occurred while updating ${fieldType}`, "error");
      }
    },
    async getSellers() {
      const res = await this.$server.search("users", {
        type: "Seller",
        warehouses: this.idWharhouse._id,
      });

      if (res && res.content.results) {
        this.filters.elements.champs[0].values = res.content.results;
      } else {
        this.filters.elements.champs[0].values = [];
      }
    },
    async remove(id) {
      this.$confirm("Confirm delete Ticket").then(async (res) => {
        if (res) {
          this.loading = true;
          const resp = await this.$server.deleteMany("tickets", {
            _id: id,
            warehouse: this.idWharhouse._id,
          });
          this.loading = false;
          if (resp && resp.content && resp.content.success) {
            alert("Ticket deleted", "success");
            await this.refresh();
          } else {
            alert(resp, "warning");
          }
        }
      });
    },
    showSellers(index) {
      this.element =
        this.element !== this.tickets[index] ? this.tickets[index] : null;
    },
    async reset() {
      await this.getTickets({ limit: this.limit });
      if(this.currentUser.type != "Seller") {
        await this.getSellers();
      }
    },
    async refresh() {
      await this.getTickets({ limit: this.limit });
      if(this.currentUser.type != "Seller") {
        await this.getSellers();
      }
    },
    async next() {
      this.filter = {
        page: ++this.paginate.currentpage,
        limit: this.limit,
      };
      await this.getTickets(this.filter);
    },
    async prev() {
      this.filter = {
        page: --this.paginate.currentpage,
        limit: this.limit,
      };
      await this.getTickets(this.filter);
    },
    async filtrer(data) {
      if(this.currentUser.type != "Seller") {
        this.filter = { limit: this.limit };
  
        this.filter.seller = data.seller;
  
        await this.getTickets(this.filter);
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0, };

      let filter;

      if(this.currentUser.type == "Seller") {
        filter = { name: data.trim(), warehouse: this.idWharhouse._id, seller: this.currentUser._id  }
      } else {
        filter = { name: data.trim(), warehouse: this.idWharhouse._id  }
      }

      this.loading = true;
      const res = await this.$server.find("tickets", filter);
      this.loading = false;

      if (res.content) {
        this.tickets = res.content;
      } else {
        this.tickets = [];
      }
    },
  },
};
</script>

<style scoped>
.btn-soft-secondary {
  background-color: rgb(225 215 246);
  color: #6c39dc;
  font-size: 8px;
  margin-left: 2px;
  margin-right: 2px;
  padding: 5px;
  border-radius: 3px;
  font-weight: 700;
}
</style>
